import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';

const ProductCategoryEdit = ({ match }) => {
  const { id } = useParams(); // Use useParams to get the id from the URL
  const recordId = useParams(); // Assuming you're using React Router
  const history = useHistory();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { isAuthenticated, companyId, userId, logout, token } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }

  }, [isAuthenticated, companyId, token, logout]);
  const [formData, setFormData] = useState({
    name: '',
    gstRate: '',
    isSubmit: false
  });

  useEffect(() => {
    fetchData('CategoryApi', `/CategoryDetails/${id}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setFormData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching Category Details:', error);
      });
  }, [id]);

  const handleChange = (event) => {
    const { name, value, type } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? !prevData[name] : value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    // if (!formData.isSubmit) {
    //   return;
    // }

    setFormData(prevData => ({
      ...prevData,
      UpdatedBy: userId,
    }));

    // Validate form data here if needed

    updateData('CategoryApi', `${id}`, formData, token)
      .then((response) => {
        console.log('Record updated successfully:', response.data);
        history.push('/ProductCategoryIndex');
      })
      .catch((error) => {
        console.error('Error updating record:', error);
        setIsLoading(false);
      });
  };

  return (
    <div className="w-full max-w-sm container mt-2 mx-auto">
      <form onSubmit={handleSubmit}>
        <div className='w-full mb-2 flex items-center'>
        <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>PRODUCT CATEGORY EDIT</h6>
        {/* <Button
            variant="contained"
            style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
            onClick={handleSubmit}
          >
            Update
          </Button>

          <Button
            variant="contained"
            color="error"
            component={Link}
            to="/ProductCategoryIndex"
            className="linkcolor"
            style={{ marginLeft: '8px' }}
          >
            Cancel
          </Button> */}
          <Tooltip title="Exit">
            <Link to="/ProductCategoryIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
              <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                Exit <ExitToAppIcon />
              </Button>
            </Link>
          </Tooltip>


          <Tooltip title="Update">

            <Button onClick={handleSubmit} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
              {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} <CheckCircleIcon />
            </Button>

          </Tooltip>

        </div>
        {/* Display success and error messages if needed */}
        {errorMessage && <p className="text-red-500">{errorMessage}</p>}
        {successMessage && <p className="text-green-500">{successMessage}</p>}


        <div className="w-full mb-4 flex">
          <div className="w-1/2 mr-2">
            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Name">
              Item Name
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="name"
              value={formData.name}
              onChange={handleChange}
              type="text"
              placeholder="Enter productName"
            />
          </div>
          <div className="w-1/8 mr-2">
            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Name">
              Code
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="code"
              value={formData.code}
              onChange={handleChange}
              type="text"
              placeholder="Enter Code"
            />
          </div>
          <div className="w-1/8 mr-2">
            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
              GST Rate
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
              name="gstRate"
              value={formData.gstRate}
              onChange={handleChange}
              type="number"
              placeholder="Enter GST Rate"
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProductCategoryEdit;
